export const TagTestIdFactory = {
    // bases
    getTagBase: () => 'tag',
    getTagCloseButtonBase: () => [TagTestIdFactory.getTagBase(), 'button'].join('-'),
    // for test id generation
    getTagTestId: (testId) => [TagTestIdFactory.getTagBase(), testId].join('-'),
    getTagCloseButtonTestId: (testId) => [TagTestIdFactory.getTagCloseButtonBase(), testId].join('-'),
};
